// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2hZcM","loader__img":"Loader_loader__img__3KgX7"};